import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateIcon from "@mui/icons-material/Create";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { errorNotify, successNotify } from "../util/functions";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useDispatch } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
import ConfirmAction from "../components/Common/ConfirmAction";
import {
  deleteModelesRapport,
  IModeleRapport,
  updateModeleRapport,
} from "../store/modeleRapportSlice";
import EditModele from "./EditModele";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeveloperBoardOffIcon from '@mui/icons-material/DeveloperBoardOff';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';

export default function MenuRapport(props: any) {
  //props
  const {
    item,
    setRenderModeleEditable,
    setLibelleModeleRapport,
    objetModele,
    libelleModeleRapport,
    libelleModeleRapportToEdit,
    setLibelleModeleRapportToEdit,
    setObjetModele,
  } = props;

  //redux
  const dispatch = useDispatch();

  //hooks
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [openEditeur, setOpenEditeur] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [openDialogConfirmAction, setOpenDialogConfirmAction] = useState(false);
  const [openEditDialogConfirmAction, setOpenEditDialogConfirmAction] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingConfirmAction, setLoadingConfirmAction] = React.useState(false);
  const [modeleRapport, setModeleRapport] = React.useState<any>({});
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [openSendDialog, setOpenSendDialog] = useState(false);
  const [addUserLoading, setAddUserLoading] = useState(false);
  const [autoriserGeneration, setAutoriserGeneration] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConfirmActionClose = () => {
    setOpenDialogConfirmAction(false);
  };

  const handleConfirmActionOpen = () => {
    setOpenDialogConfirmAction(true);
  };
  const handleEditDialogConfirmActionClose = () => {
    setOpenEditDialogConfirmAction(false);
  };

  const handleClickOnEditModeleRapport = (modeleAModifie: IModeleRapport) => {
    setObjetModele(modeleAModifie);
    setLibelleModeleRapportToEdit(modeleAModifie.libelleModeleRapport);
    setOpenEditDialogConfirmAction(true);
  };

  //envoyer rapport en ligne 
  const handleSendDialogClose = () => {
    setOpenSendDialog(false);
  };

  //Ouvrir le boite d'alerte d'autorisation de génération de rapport
  const handleAutorisationRapportDialogOpen = () => {
    setAutoriserGeneration(true);
  };

  //Fermer le boite d'alerte d'autorisation de génération de rapport
  const handleAutorisationRapportDialogClose = () => {
    setAutoriserGeneration(false);
  };




  const handleClickOnSendDialog = (modeleAModifie: IModeleRapport) => {
    setObjetModele(modeleAModifie);
    setLibelleModeleRapportToEdit(modeleAModifie.libelleModeleRapport);
    setOpenSendDialog(true);
  };

  // envoyer modèle rapport en ligne
  const handleSendOnline = async () => {
    try {
      // const newData = modelesRapport.map(
      //   (item: IModeleRapport, index: number) => {
      //     const indexModele = modelesSelected.findIndex(
      //       (elt: string) => elt === item.idModeleRapport
      //     );
      //     if (indexModele < 0) {
      //       return item;
      //     } else {
      //       return { ...item, status: 1 };
      //     }
      //   }
      // );
      //  dispatch(updateModelesRapportApresEnvoieEnLigne(newData));

      setAddUserLoading(true);

      const apiPayload = {
        idModeleRapport: objetModele.idModeleRapport,
        libelleModeleRapport: objetModele.libelleModeleRapport,
        // planModeleRapport: objetModele.planModeleRapport,
        revision: objetModele.revision + 1,
        status: objetModele.status,
      };

      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/envoyermodelerapportenligne",
        apiPayload
      );
      if (res.status === 1) {
        // dispatch(updateModelesRapportApresEnvoieEnLigne(apiPayload));
        dispatch(updateModeleRapport(res.data));
        setAddUserLoading(false);
        handleSendDialogClose()
        successNotify("Modèle de rapport envoyé en ligne avec succès.");
      } else {
        console.log("status !==1");
        setAddUserLoading(false);
        errorNotify("Erreur d'envoie en ligne du modèle de rapport.");
      }
    } catch (error) {
      setAddUserLoading(false);
      console.log("🚀 ~ file: handleSave ~ error", error);
      errorNotify("Erreur d'envoie en ligne du modèle de rapport.");
    }
  };

  //suppression 
  const handleDeleteModeleRapport = async () => {
    try {
      setLoading(true);
      const apiPayload = {
        idModeleRapport: item.idModeleRapport,
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/supprimermodelerapport",
        apiPayload
      );
      if (res.status === 1) {
        //   const parsedData =  {
        //     ...res.data,
        //     planModeleRapport: JSON.parse(res.data.planModeleRapport)
        // };
        dispatch(deleteModelesRapport(res.data));
        successNotify("Modèle de rapport supprimé avec succès.");
        setLoading(false);
        handleConfirmActionClose();
      } else {
        console.log("status !==1");
        setLoading(false);
        errorNotify("Erreur de suppression du modèle.");
      }
    } catch (error) {
      console.log("🚀 ~ file: handleSave ~ error", error);
      setLoading(false);
      errorNotify("Erreur de suppression du modèle.");
    }
  };

  const handleEditItem = async () => {
    try {
      setLoadingEdit(true);
      const apiPayload = {
        libelleModeleRapport: libelleModeleRapportToEdit,
        idModeleRapport: objetModele.idModeleRapport,
        planModeleRapport: objetModele.planModeleRapport,
        revision: objetModele.revision,
        status: objetModele.status,
      };
      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/modifiermodelerapport",
        apiPayload
      );
      if (res.status === 1) {
        //   const parsedData =  {
        //     ...res.data,
        //     planModeleRapport: JSON.parse(res.data.planModeleRapport)
        // };
        dispatch(updateModeleRapport(res.data));
        setLibelleModeleRapport("");
        setLoadingEdit(false);
        handleEditDialogConfirmActionClose();
        successNotify("Le libellé du modèle de rapport a été modifié avec succès.");
      } else {
        console.log("status !==1");
        setLoadingEdit(false);
        errorNotify("Erreur de modification du libellé du modèle de rapport.");
      }
    } catch (error) {
      console.log("🚀 ~ file: handleSave ~ error", error);
      setLoadingEdit(false);
      errorNotify("Erreur de modification du libellé du modèle de rapport.");
    }
  };


  //Executer l'api  qui autorise la génération du rapport lié à cet modèle
  const handleAutorisationGenereRapport = async (e: any) => {
    e.preventDefault();
    try {
      setLoading(true);
      const statusStatus: number = item.status !== 2 ? 2 : 1;
      const apiPayload = {
        idModeleRapport: item.idModeleRapport,
        status: statusStatus
      };

      const res: any = await apiClient.post(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/autorisegeneration",
        apiPayload
      );

      if (res.status === 1) {
        dispatch(updateModeleRapport(res.data));
        setLoading(false);
        handleAutorisationRapportDialogClose();
        successNotify("Autorisation éffectuée avec succès");
      } else {
        setLoading(false);
        errorNotify("Echèc de l'autorisation.");
      }
    } catch (error) {
      setLoading(false);
      console.log(
        "🚀 ~ file: MenuRapport.tsx ~ line 80 ~ handleDeleteRapport ~ error",
        error
      );
      errorNotify("Une erreur s'est produite.");
    }
  };


  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            handleClickOnSendDialog(item);
          }}
        >
          <ListItemIcon>
            <SendIcon fontSize="small" />
          </ListItemIcon>
          Publier
        </MenuItem>

        <MenuItem
          onClick={handleAutorisationRapportDialogOpen}>
          <ListItemIcon>
            {item.status === 1
              ? <DeveloperBoardIcon fontSize="small" />
              : <DeveloperBoardOffIcon fontSize="small" />

            }
          </ListItemIcon>
          {item.status === 1
            ? "Autoriser la génération"
            : "Annuler l'autorisation de génération"
          }
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClickOnEditModeleRapport(item);
          }}
        >
          <ListItemIcon>
            <CreateIcon fontSize="small" />
          </ListItemIcon>
          Modifier le libellé
        </MenuItem>

        <MenuItem
          onClick={() => {
            setModeleRapport(item);
            handleConfirmActionOpen();
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Supprimer
        </MenuItem>
      </Menu>

      <ConfirmAction
        title="Suppression"
        dialogContent={`Voulez vous réellement supprimer le modèle de rapport: (${item.libelleModeleRapport})?`}
        actionLabel="Supprimer"
        open={openDialogConfirmAction}
        handleClose={handleConfirmActionClose}
        actionFunction={handleDeleteModeleRapport}
        addLoading={loading}
        iconeSauveButton={<DeleteIcon />}
      />

      <ConfirmAction
        title="Modification"
        dialogContent={
          <EditModele
            objetModele={objetModele}
            libelleModeleRapportToEdit={libelleModeleRapportToEdit}
            setLibelleModeleRapportToEdit={setLibelleModeleRapportToEdit}
          />
        }
        actionLabel="Modifier"
        open={openEditDialogConfirmAction}
        handleClose={handleEditDialogConfirmActionClose}
        actionFunction={handleEditItem}
        addLoading={loadingEdit}
        iconeSauveButton={<ModeEditIcon />}
      />

      <ConfirmAction
        title="Publication du modèle"
        dialogContent={`Voulez vous réellement envoyer le modèle de rapport: (${item.libelleModeleRapport}) en ligne?`}
        actionLabel="Envoyer"
        open={openSendDialog}
        handleClose={handleSendDialogClose}
        actionFunction={handleSendOnline}
        addLoading={loading}
        iconeSauveButton={<SendIcon />}
      />

      <ConfirmAction
        title="Autorisation de génération"
        dialogContent={`Voulez vous réellement autoriser la génération des rapports liés au modèle intitulé: (${item.libelleModeleRapport})?`}
        actionLabel={item.status === 1
          ? "Autoriser"
          : "Annuler l'autorisation"
        }
        open={autoriserGeneration}
        handleClose={handleAutorisationRapportDialogClose}
        actionFunction={handleAutorisationGenereRapport}
        addLoading={loading}
        iconeSauveButton={item.status === 1
          ? <DeveloperBoardIcon fontSize="small" />
          : <DeveloperBoardOffIcon fontSize="small" />
        }
      />
    </React.Fragment>
  );
}
